import organizationAdmins from './organization-admins.json';

export default {
  organizationAdmins,
};
